import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-who-component',
  templateUrl: './who-component.component.html',
  styleUrls: ['./who-component.component.scss']
})
export class WhoComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
